export default __webpack_public_path__ + "static/image-BUIE-AI-1e91da2c1ef5f9424fc1f53badf21ee5.png";